export default {
    name: 'Lesson',
    data () {
        return {
           data:[
			   {
				   id:1,
				   name:'电子技术基础(一)',
				   time:21,
				   date:'2017/5/10'
			   },{
				   id:2,
				   name:'电子技术基础(二)',
				   time:22,
				   date:'2017/5/10'
			   },{
				   id:3,
				   name:'红外技术',
				   time:15,
				   date:'2017/5/10'
			   },{
				   id:4,
				   name:'计算机辅助工程与基础理论',
				   time:13,
				   date:'2017/5/10'
			   },{
				   id:5,
				   name:'通信电子线路(一)',
				   time:22,
				   date:'2017/5/10'
			   },{
				   id:6,
				   name:'通信电子线路(二)',
				   time:30,
				   date:'2017/5/10'
			   },{
				   id:7,
				   name:'信息安全现状与发展',
				   time:3,
				   date:'2017/5/10'
			   },{
				   id:8,
				   name:'信息资源建设',
				   time:40,
				   date:'2017/5/10'
			   },{
				   id:9,
				   name:'智能信息处理',
				   time:26,
				   date:'2017/5/10'
			   },{
				   id:10,
				   name:'信息管理学基础',
				   time:3,
				   date:'2017/5/10'
			   },{
				   id:11,
				   name:'智能信息检索',
				   time:24,
				   date:'2017/5/10'
			   },{
				   id:12,
				   name:'移动技术支持的可持续性无缝学习研究',
				   time:2,
				   date:'2017/5/10'
			   },{
				   id:13,
				   name:'计算机存储系统的研究现状和发展趋势',
				   time:3,
				   date:'2017/5/10'
			   },{
				   id:14,
				   name:'工匠精神解读与培育的思考',
				   time:'5',
				   date:'2017/5/18'
			   },{
				   id:15,
				   name:'精益求精立广东制造之本',
				   time:4,
				   date:'2017/5/18'
			   },{
				   id:16,
				   name:'创新精神竖广东制造之魂',
				   time:'4',
				   date:'2017/5/18'
			   },{
				   id:17,
				   name:'让技能型人才拥有一颗匠心',
				   time:5,
				   date:'2017/5/18'
			   },{
				   id:18,
				   name:'以供给侧改革推进跨区域产业共建',
				   time:'18',
				   date:'2017/5/18'
			   },{
				   id:19,
				   name:'物理化学(上)',
				   time:'24',
				   date:'2017/6/15'
			   },{
				   id:20,
				   name:'物理化学(下)',
				   time:18,
				   date:'2017/6/15'
			   },{
				   id:21,
				   name:'大数据前沿技术及应用',
				   time:'18',
				   date:'2017/6/23'
			   },{
				   id:22,
				   name:'Premiere字幕',
				   time:3,
				   date:'2017/7/5'
			   },{
				   id:23,
				   name:'从中美文化看大学生创业和3D打印技术的未来',
				   time:'1.5',
				   date:'2017/7/5'
			   },{
				   id:24,
				   name:'流行语反应的时尚文化专题',
				   time:10,
				   date:'2017/7/5'
			   },{
				   id:25,
				   name:'数字媒体艺术与图形工业的关系',
				   time:'3',
				   date:'2017/7/5'
			   },{
				   id:26,
				   name:'虚拟现实与可视化的技术及应用',
				   time:2,
				   date:'2017/7/5'
			   },{
				   id:27,
				   name:'云计算与虚拟化技术',
				   time:'5',
				   date:'2017/7/5'
			   },{
				   id:28,
				   name:'宽带移动无线通信的发展与创新',
				   time:13,
				   date:'2017/7/5'
			   },{
				   id:29,
				   name:'高级农业经济学(上)',
				   time:9,
				   date:'2017/7/13'
			   },{
				   id:30,
				   name:'高级农业经济学(下)',
				   time:11.5,
				   date:'2017/7/13'
			   },{
				   id:31,
				   name:'世界文明体系中的中国农业',
				   time:1.5,
				   date:'2017/7/13'
			   },{
				   id:32,
				   name:'畜产品加工学',
				   time:'10',
				   date:'2017/7/13'
			   },{
				   id:33,
				   name:'畜产食品工艺学',
				   time:10,
				   date:'2017/7/13'
			   },{
				   id:34,
				   name:'中国人的管理行为分析',
				   time:8,
				   date:'2017/7/21'
			   },{
				   id:35,
				   name:'管理者的哲学修养',
				   time:4,
				   date:'2017/7/21'
			   },{
				   id:36,
				   name:'人力资源管理——基于中国文化与经济特征',
				   time:10,
				   date:'2017/7/21'
			   },{
				   id:37,
				   name:'管理环境与管理工作的开展',
				   time:2,
				   date:'2017/7/21'
			   },{
				   id:38,
				   name:'传播学研究方法:传播研究的想象',
				   time:3,
				   date:'2017/8/2'
			   },{
				   id:39,
				   name:'媒体文化与传播研究的兴起',
				   time:2,
				   date:'2017/8/2'
			   },{
				   id:40,
				   name:'如何提高新闻写作能力',
				   time:20,
				   date:'2017/8/2'
			   },{
				   id:41,
				   name:'探读影视的奥妙',
				   time:3,
				   date:'2017/8/2'
			   },{
				   id:42,
				   name:'新媒体传媒理论',
				   time:3,
				   date:'2017/8/2'
			   },{
				   id:43,
				   name:'新闻媒体摄影构图技术',
				   time:24,
				   date:'2017/8/2'
			   },{
				   id:44,
				   name:'新闻摄影艺术与技巧',
				   time:10,
				   date:'2017/8/2'
			   },{
				   id:45,
				   name:'影视表演与拍摄实践2',
				   time:12,
				   date:'2017/8/2'
			   },{
				   id:46,
				   name:'影视制作——编剧如何讲故事',
				   time:14,
				   date:'2017/8/2'
			   },{
				   id:47,
				   name:'在中国如何进行调查性报道',
				   time:4,
				   date:'2017/8/2'
			   },{
				   id:48,
				   name:'专家教你摄影技术与技巧',
				   time:9,
				   date:'2017/8/2'
			   },{
				   id:49,
				   name:'高分子物理理论',
				   time:16,
				   date:'2017/8/9'
			   },{
				   id:50,
				   name:'精细化学',
				   time:8,
				   date:'2017/8/9'
			   },{
				   id:51,
				   name:'聚合物的非晶态(上)',
				   time:11.5,
				   date:'2017/8/9'
			   },{
				   id:52,
				   name:'聚合物的非晶态(下)',
				   time:13.5,
				   date:'2017/8/9'
			   },{
				   id:53,
				   name:'矿产资源',
				   time:13,
				   date:'2017/8/9'
			   },{
				   id:54,
				   name:'热工基础(上)',
				   time:16,
				   date:'2017/8/9'
			   },{
				   id:55,
				   name:'热工基础(下)',
				   time:13,
				   date:'2017/8/2'
			   },{
				   id:56,
				   name:'行动学习理论',
				   time:18,
				   date:'2017/8/9'
			   },{
				   id:57,
				   name:'资源潜力评价与勘探工程',
				   time:12.5,
				   date:'2017/8/9'
			   },{
				   id:58,
				   name:'资源循环科学与工程概论',
				   time:10,
				   date:'2017/8/9'
			   },{
				   id:59,
				   name:'英国工业革命',
				   time:2,
				   date:'2017/8/18'
			   },{
				   id:60,
				   name:'日本产业革命的六大特点',
				   time:1,
				   date:'2017/8/18'
			   },{
				   id:61,
				   name:'迈向现代工业文明',
				   time:2,
				   date:'2017/8/18'
			   },{
				   id:62,
				   name:'以创新为导向的世界工厂',
				   time:2,
				   date:'2017/8/18'
			   },{
				   id:63,
				   name:'产品创新设计案例——智能数控机床',
				   time:1,
				   date:'2017/8/18'
			   },{
				   id:64,
				   name:'电子束光刻与纳米光刻技术',
				   time:5,
				   date:'2017/8/18'
			   },{
				   id:65,
				   name:'控制工程基础',
				   time:22,
				   date:'2017/8/18'
			   },{
				   id:66,
				   name:'新能源材料研究进展',
				   time:1.5,
				   date:'2017/8/18'
			   },{
				   id:67,
				   name:'工程生态学—生态系统可持续发展的理论基础',
				   time:2.5,
				   date:'2017/8/18'
			   },{
				   id:68,
				   name:'工业和经济生态学',
				   time:5,
				   date:'2017/8/18'
			   },{
				   id:69,
				   name:'CAE技术及其应用',
				   time:2,
				   date:'2017/8/18'
			   },{
				   id:70,
				   name:'面积微纳米结构之压印制成技术与工业应用',
				   time:4,
				   date:'2017/8/18'
			   },{
				   id:71,
				   name:'工业原材料和部品循环利用技术',
				   time:4,
				   date:'2017/8/18'
			   },{
				   id:72,
				   name:'先进的达芬奇(daVinciS HD)机器人手术系统',
				   time:1,
				   date:'2017/8/18'
			   },{
				   id:73,
				   name:'全息术与微纳光电子学',
				   time:1.5,
				   date:'2017/8/18'
			   },{
				   id:74,
				   name:'从中美文化看大学生创业和3D打印技术的未来',
				   time:1.5,
				   date:'2017/8/18'
			   },{
				   id:75,
				   name:'工业实时以太网技术及其应用',
				   time:1.5,
				   date:'2017/8/18'
			   },{
				   id:76,
				   name:'机器人焊接技术',
				   time:4.5,
				   date:'2017/8/18'
			   },{
				   id:77,
				   name:'“粤教云”及其发展',
				   time:0.5,
				   date:'2017/8/18'
			   },{
				   id:78,
				   name:'虚拟现实与可视化的技术及应用',
				   time:2,
				   date:'2017/8/18'
			   },{
				   id:79,
				   name:'高级人工智能(一)',
				   time:20,
				   date:'2017/8/18'
			   },{
				   id:80,
				   name:'高级人工智能(二)',
				   time:23,
				   date:'2017/8/18'
			   },{
				   id:81,
				   name:'传播心理学研究',
				   time:20,
				   date:'2017/9/4'
			   },{
				   id:82,
				   name:'高级软件编程技术',
				   time:13,
				   date:'2017/9/4'
			   },{
				   id:83,
				   name:'广播影视拉片艺术',
				   time:16,
				   date:'2017/9/4'
			   },{
				   id:84,
				   name:'探讨电视剧创作艺术',
				   time:25,
				   date:'2017/9/4'
			   },{
				   id:85,
				   name:'影视动画编导初级',
				   time:6,
				   date:'2017/9/4'
			   },{
				   id:86,
				   name:'中国电视内容生产的潮流与趋势',
				   time:3,
				   date:'2017/9/4'
			   },{
				   id:87,
				   name:'创新能力的培养',
				   time:24,
				   date:'2017/9/6'
			   },{
				   id:88,
				   name:'创新思维',
				   time:24,
				   date:'2017/9/6'
			   },{
				   id:89,
				   name:'高等材料化学',
				   time:5,
				   date:'2017/9/6'
			   },{
				   id:90,
				   name:'高分子加工工艺(上)',
				   time:8.5,
				   date:'2017/9/6'
			   },{
				   id:91,
				   name:'高分子加工工艺(下)',
				   time:15.5,
				   date:'2017/9/6'
			   },{
				   id:92,
				   name:'材料加工自动化',
				   time:15,
				   date:'2017/9/6'
			   },{
				   id:93,
				   name:'化工流体流动',
				   time:26,
				   date:'2017/9/6'
			   },{
				   id:94,
				   name:'佛教美术研究(一)',
				   time:24,
				   date:'2017/9/11'
			   },{
				   id:95,
				   name:'佛教美术研究(二)',
				   time:25,
				   date:'2017/9/11'
			   },{
				   id:96,
				   name:'民俗学原理',
				   time:30,
				   date:'2017/9/11'
			   },{
				   id:97,
				   name:'中国剧场与舞台的变迁',
				   time:6,
				   date:'2017/9/11'
			   },{
				   id:98,
				   name:'专业摄影技术',
				   time:4,
				   date:'2017/9/11'
			   },{
				   id:99,
				   name:'中国山水画临摹教学',
				   time:2,
				   date:'2017/9/11'
			   },{
				   id:100,
				   name:'AE动画技术',
				   time:3,
				   date:'2017/9/18'
			   },{
				   id:101,
				   name:'AE高级特效',
				   time:4,
				   date:'2017/9/18'
			   },{
				   id:102,
				   name:'AE三维合成',
				   time:3,
				   date:'2017/9/18'
			   },{
				   id:103,
				   name:'AE渲染技术',
				   time:3,
				   date:'2017/9/18'
			   },{
				   id:104,
				   name:'初探电视语境研究解析',
				   time:4,
				   date:'2017/9/18'
			   },{
				   id:105,
				   name:'广告策划能力提升与案例分析',
				   time:18,
				   date:'2017/9/18'
			   },{
				   id:106,
				   name:'如何做好新闻编辑与评论',
				   time:27,
				   date:'2017/9/18'
			   },{
				   id:107,
				   name:'影视合成基础知识',
				   time:4,
				   date:'2017/9/18'
			   },{
				   id:108,
				   name:'钢琴即兴伴奏',
				   time:3,
				   date:'2017/9/25'
			   },{
				   id:109,
				   name:'近现代音乐',
				   time:11.5,
				   date:'2017/9/25'
			   },{
				   id:110,
				   name:'就昆风歌剧《梦蝶》谈音乐创作的若干问题',
				   time:1.5,
				   date:'2017/9/25'
			   },{
				   id:111,
				   name:'昆曲的形成与京剧的发展',
				   time:6,
				   date:'2017/9/25'
			   },{
				   id:112,
				   name:'清代戏剧文化',
				   time:10,
				   date:'2017/9/25'
			   },{
				   id:113,
				   name:'双簧管演奏与教学法',
				   time:11,
				   date:'2017/9/25'
			   },{
				   id:114,
				   name:'音乐考古',
				   time:16,
				   date:'2017/9/25'
			   },{
				   id:115,
				   name:'音乐戏剧',
				   time:18,
				   date:'2017/9/25'
			   },{
				   id:116,
				   name:'音乐学分析',
				   time:17,
				   date:'2017/9/25'
			   },{
				   id:117,
				   name:'元代戏曲',
				   time:21.5,
				   date:'2017/9/25'
			   },{
				   id:118,
				   name:'中国民族民间音乐历程的再认识',
				   time:10,
				   date:'2017/9/25'
			   },{
				   id:119,
				   name:'机器人焊接技术',
				   time:4.5,
				   date:'2017/9/29'
			   },{
				   id:120,
				   name:'“粤教云”及其发展',
				   time:0.5,
				   date:'2017/9/29'
			   },{
				   id:121,
				   name:'虚拟现实与可视化的技术及应用',
				   time:2,
				   date:'2017/9/29'
			   },{
				   id:122,
				   name:'高级人工智能(一)',
				   time:20,
				   date:'2017/9/29'
			   },{
				   id:123,
				   name:'高级人工智能(二)',
				   time:23,
				   date:'2017/9/29'
			   },{
				   id:124,
				   name:'关于人工智能科学之基础问题的哲学反思',
				   time:6,
				   date:'2017/9/29'
			   },{
				   id:125,
				   name:'智能计算及其前沿研究',
				   time:27,
				   date:'2017/9/29'
			   },{
				   id:126,
				   name:'智能控制',
				   time:32,
				   date:'2017/9/29'
			   },{
				   id:127,
				   name:'微纳传感器在物联网中的智能应用(之一)',
				   time:7,
				   date:'2017/9/29'
			   },{
				   id:128,
				   name:'微纳传感器在物联网中的智能应用(之二)',
				   time:3,
				   date:'2017/9/29'
			   },{
				   id:129,
				   name:'人工智能发展与智能科学技术产生',
				   time:0.5,
				   date:'2017/9/29'
			   },{
				   id:130,
				   name:'曲式与作品分析',
				   time:21,
				   date:'2017/10/12'
			   },{
				   id:131,
				   name:'中国古代音乐史',
				   time:29,
				   date:'2017/10/12'
			   },{
				   id:132,
				   name:'中国民歌选唱',
				   time:10,
				   date:'2017/10/12'
			   },{
				   id:133,
				   name:'中国戏剧史(上)',
				   time:38,
				   date:'2017/10/12'
			   },{
				   id:134,
				   name:'中国戏剧史',
				   time:35,
				   date:'2017/10/12'
			   },{
				   id:135,
				   name:'中国戏曲悲剧史',
				   time:30,
				   date:'2017/10/12'
			   },{
				   id:136,
				   name:'中国音乐思想的范式问题',
				   time:2,
				   date:'2017/10/16'
			   },{
				   id:137,
				   name:'光纤通信技术-绪论',
				   time:5,
				   date:'2017/10/16'
			   },{
				   id:138,
				   name:'广告艺术理论探析',
				   time:32,
				   date:'2017/10/16'
			   },{
				   id:139,
				   name:'计算机网络——网络层',
				   time:11,
				   date:'2017/10/16'
			   },{
				   id:140,
				   name:'揭秘阿凡达——漫谈艺术、科技与生活',
				   time:2,
				   date:'2017/10/16'
			   },{
				   id:141,
				   name:'青年电影，让梦想飞',
				   time:4,
				   date:'2017/10/16'
			   },{
				   id:142,
				   name:'探索外国新闻传播历程',
				   time:28,
				   date:'2017/10/16'
			   },{
				   id:143,
				   name:'新闻学与纪录片',
				   time:36,
				   date:'2017/10/16'
			   },{
				   id:144,
				   name:'影视剪辑技术与技巧',
				   time:25,
				   date:'2017/10/16'
			   },{
				   id:145,
				   name:'播音与主持艺术培养',
				   time:21,
				   date:'2017/10/20'
			   },{
				   id:146,
				   name:'传媒变革视野下的新闻传播',
				   time:13,
				   date:'2017/10/20'
			   },{
				   id:147,
				   name:'从新闻历史中寻找智慧',
				   time:3,
				   date:'2017/10/20'
			   },{
				   id:148,
				   name:'电影艺术理论研究阐述',
				   time:17,
				   date:'2017/10/20'
			   },{
				   id:149,
				   name:'计算机网络管理与网络安全',
				   time:3,
				   date:'2017/10/20'
			   },{
				   id:150,
				   name:'计算机网络——数据链路层和局域网',
				   time:9,
				   date:'2017/10/20'
			   },{
				   id:151,
				   name:'计算机网络协议和体系结构',
				   time:4,
				   date:'2017/10/20'
			   },{
				   id:152,
				   name:'计算机网络——应用层',
				   time:6,
				   date:'2017/10/20'
			   },{
				   id:153,
				   name:'计算机网络——运输层',
				   time:5,
				   date:'2017/10/20'
			   },{
				   id:154,
				   name:'我国广告产业转型的重要标志——第十九届中国国际广告节解读',
				   time:2,
				   date:'2017/10/20'
			   },{
				   id:155,
				   name:'无线通信技术发展及关键技术',
				   time:2,
				   date:'2017/10/20'
			   },{
				   id:156,
				   name:'影视表演与拍摄实践',
				   time:12,
				   date:'2017/10/20'
			   },{
				   id:157,
				   name:'读者服务工作的主要内容、方法与策略',
				   time:3,
				   date:'2017/10/25'
			   },{
				   id:158,
				   name:'数据挖掘对图书馆学、情报学研究的影响',
				   time:1,
				   date:'2017/10/25'
			   },{
				   id:159,
				   name:'图书馆研究的历史观与世界观',
				   time:2,
				   date:'2017/10/25'
			   },{
				   id:160,
				   name:'新课程背景下的数字图书馆建设与应用',
				   time:2,
				   date:'2017/10/25'
			   },{
				   id:161,
				   name:'信息资源共享研究',
				   time:14,
				   date:'2017/10/25'
			   },{
				   id:162,
				   name:'编辑的素质与修养提升',
				   time:2,
				   date:'2017/10/26'
			   },{
				   id:163,
				   name:'对话电影当下——后第六代导演',
				   time:2,
				   date:'2017/10/26'
			   },{
				   id:164,
				   name:'光导纤维',
				   time:9,
				   date:'2017/10/26'
			   },{
				   id:165,
				   name:'广播电视语体',
				   time:31,
				   date:'2017/10/26'
			   },{
				   id:166,
				   name:'新媒体发展与电影的再定义',
				   time:2,
				   date:'2017/10/26'
			   },{
				   id:167,
				   name:'新闻传播的媒介和内容:新中国60年来新闻报道方式的演变',
				   time:4,
				   date:'2017/10/26'
			   },{
				   id:168,
				   name:'新闻摄影的技巧交流',
				   time:3,
				   date:'2017/10/26'
			   },{
				   id:169,
				   name:'影视美学艺术解析',
				   time:17,
				   date:'2017/10/26'
			   },{
				   id:170,
				   name:'转型中国的问题与新闻人的担当——一个记者对当代中国的理解',
				   time:3,
				   date:'2017/10/26'
			   },{
				   id:171,
				   name:'环保主题互动法制保障论',
				   time:3,
				   date:'2017/11/3'
			   },{
				   id:172,
				   name:'科技、环境与哲学',
				   time:13,
				   date:'2017/11/3'
			   },{
				   id:173,
				   name:'环境工程设计原理',
				   time:25,
				   date:'2017/11/3'
			   },{
				   id:174,
				   name:'节能减排的政策内涵',
				   time:2,
				   date:'2017/11/3'
			   },{
				   id:175,
				   name:'节能技术与低碳生活',
				   time:1,
				   date:'2017/11/3'
			   },{
				   id:176,
				   name:'水污染控制的低碳化战略',
				   time:1,
				   date:'2017/11/3'
			   },{
				   id:177,
				   name:'我国汽车及鞥呢减排现状与对策',
				   time:1,
				   date:'2017/11/3'
			   },{
				   id:178,
				   name:'绿色建筑技术的适宜性',
				   time:2,
				   date:'2017/11/3'
			   },{
				   id:179,
				   name:'环境挑战与绿色环境',
				   time:2,
				   date:'2017/11/3'
			   },{
				   id:180,
				   name:'css与过程工业节能减排新技术',
				   time:3,
				   date:'2017/11/3'
			   },{
				   id:181,
				   name:'建筑节能领域相变蓄能应用基础研究',
				   time:2,
				   date:'2017/11/3'
			   },{
				   id:182,
				   name:'生态建筑与绿色生活',
				   time:4,
				   date:'2017/11/3'
			   },{
				   id:183,
				   name:'中国电视的评论时代',
				   time:1,
				   date:'2017/11/7'
			   },{
				   id:184,
				   name:'电视新闻记者的角色定位',
				   time:2,
				   date:'2017/11/7'
			   },{
				   id:185,
				   name:'电视传像基础',
				   time:11,
				   date:'2017/11/7'
			   },{
				   id:186,
				   name:'电视摄像技术',
				   time:17,
				   date:'2017/11/7'
			   },{
				   id:187,
				   name:'新闻舆论引导与监督',
				   time:9,
				   date:'2017/11/7'
			   },{
				   id:188,
				   name:'影视美术设计绪论(一)',
				   time:15,
				   date:'2017/11/7'
			   },{
				   id:189,
				   name:'影视美术设计绪论(二)',
				   time:15,
				   date:'2017/11/7'
			   },{
				   id:190,
				   name:'影视美学：欧洲艺术电影美学',
				   time:3,
				   date:'2017/11/7'
			   },{
				   id:191,
				   name:'影视摄录像技术',
				   time:18,
				   date:'2017/11/7'
			   },{
				   id:192,
				   name:'电视专题片创作(一)',
				   time:6,
				   date:'2017/11/9'
			   },{
				   id:193,
				   name:'电视专题创作(二)',
				   time:8,
				   date:'2017/11/9'
			   },{
				   id:194,
				   name:'电影背后的文学',
				   time:2,
				   date:'2017/11/9'
			   },{
				   id:195,
				   name:'电影建构国家',
				   time:3,
				   date:'2017/11/9'
			   },{
				   id:196,
				   name:'电影艺术概论',
				   time:17,
				   date:'2017/11/9'
			   },{
				   id:197,
				   name:'华语电影的跨学科研究',
				   time:3,
				   date:'2017/11/9'
			   },{
				   id:198,
				   name:'论纪录片的创作',
				   time:2,
				   date:'2017/11/9'
			   },{
				   id:199,
				   name:'浅谈创新能力的培养',
				   time:2,
				   date:'2017/11/9'
			   },{
				   id:200,
				   name:'“跨文化传播”培训专题',
				   time:11,
				   date:'2017/11/14'
			   },{
				   id:201,
				   name:'社会化学习:在社交网络连接的世界中学习',
				   time:1,
				   date:'2017/11/14'
			   },{
				   id:202,
				   name:'摄影与欣赏',
				   time:2,
				   date:'2017/11/14'
			   },{
				   id:203,
				   name:'台词艺术',
				   time:35,
				   date:'2017/11/14'
			   },{
				   id:204,
				   name:'影视艺术——影视艺术的商业属性',
				   time:6,
				   date:'2017/11/14'
			   },{
				   id:205,
				   name:'影视艺术——影视艺术的语言系统(上)',
				   time:7,
				   date:'2017/11/14'
			   },{
				   id:206,
				   name:'影视艺术——影视艺术的语言系统(下)',
				   time:10,
				   date:'2017/11/14'
			   },{
				   id:207,
				   name:'船舶结构力学',
				   time:20,
				   date:'2017/11/17'
			   },{
				   id:208,
				   name:'船舶原理Ⅱ',
				   time:14,
				   date:'2017/11/17'
			   },{
				   id:209,
				   name:'高级海洋地质学',
				   time:23,
				   date:'2017/11/17'
			   },{
				   id:210,
				   name:'海洋科学导论',
				   time:6,
				   date:'2017/11/17'
			   },{
				   id:211,
				   name:'海洋学',
				   time:16,
				   date:'2017/11/17'
			   },{
				   id:212,
				   name:'激光雷达测风技术',
				   time:4,
				   date:'2017/11/17'
			   },{
				   id:213,
				   name:'电视导演的思维特性',
				   time:5.5,
				   date:'2017/11/22'
			   },{
				   id:214,
				   name:'新闻实务——报道策划',
				   time:4,
				   date:'2017/11/22'
			   },{
				   id:215,
				   name:'新闻实务——新闻评论',
				   time:9,
				   date:'2017/11/22'
			   }
		   ]
            
        }
    },
    methods: {
        draw(){
            var data = this.data
            var chart = new G2.Chart({
                container: 'lesson',
                forceFit: true,
                padding:'auto',
				height:7000
            });
            chart.source(data);
            chart.axis('name', {
                label: {
                    offset: 12
                }
            });
            chart.coord().transpose();
            chart.scale('time', {
                alias: '学时',
            });
            chart.scale('date', {
                alias: '上线日期',
            });
            
            chart.interval().position('name*time').tooltip('time*date');
            chart.render();
        },
	   
		ajax(url, fnSuccess, fnFail) {
			//创建对象
			var xhr = new XMLHttpRequest();
			//alert(xhr.readyState);:0
			//链接服务器 请求方式   请求文件  异步或同步 异步
			xhr.open("POST", url, true);
			//alert(xhr.readyState);:1
			xhr.setRequestHeader('content-type','application/x-www-form-urlencoded');
			//发送请求
			xhr.send();
			//alert(xhr.readyState);:1
			//接收返回
			xhr.onreadystatechange = function() {
				//alert(xhr.readyState);:2,3,4
				if(xhr.readyState === 4) {
					//xhr.status http状态码：
					//301：永久重定向
					//302：临时重定向   tamall.com=>www.tamall.com
					//304也是成功得
					if(xhr.status >= 200 && xhr.status < 300) {
						var json = null;
						json = JSON.parse(xhr.responseText);
						fnSuccess(json);
					} else {
						fnFail(xhr.status);
					}
				}
			}
		},

		getData(){
			let me = this
			me.ajax('https://coral3.com/yes/public/api/killClass',function(res){
				for(let a of res){
					a.time = Number(a.time)
					a.date = a.date.slice(0,10)
				}
				me.data.push(...res)
				me.draw()
			},function(fail){
				console.log(fail)
			})
		}

    },
    mounted(){
		
		this.getData()
	},
	
}